var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimation = function SvgAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#A9A5FF",
    fillOpacity: 0.12,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31 19.877a6.504 6.504 0 1 1-13.009 0 6.504 6.504 0 0 1 13.009 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.574 14.242a5.636 5.636 0 1 0 .064 11.271c.16-.003.178-.08.046-.168a6.59 6.59 0 0 1-2.928-5.468 6.58 6.58 0 0 1 2.933-5.468c.133-.089.114-.164-.045-.166z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.56 15.318a4.56 4.56 0 0 0 0 9.12h.046c.132-.002.147-.065.037-.14a5.33 5.33 0 0 1-2.363-4.42c0-1.838.942-3.465 2.368-4.42.11-.074.095-.136-.038-.137q-.026-.001-.05-.003"
  })));
};
export default SvgAnimation;